import React, { useState } from 'react';

export const RecurringItemContext = React.createContext();

/**
 * Provider for the RecurringItem context
 * @returns
 *
 */
const RecurringItemProvider = ({ children }) => {
    const [isRecurringItem, setIsRecurringItem] = useState(false);
    const [isRecurringItemWarningBlockingCreate, setIsRecurringItemWarningBlockingCreate] = useState(false);
    const [tooManyItemsError, setTooManyItemsError] = useState(false);
    const [recurringAmount, setRecurringAmount] = useState(0);

    return (
        <RecurringItemContext.Provider
            value={{
                isRecurringItem, // Wrap
                setIsRecurringItem,
                isRecurringItemWarningBlockingCreate,
                setIsRecurringItemWarningBlockingCreate,
                recurringAmount,
                setRecurringAmount,
                tooManyItemsError,
                setTooManyItemsError,
            }}
        >
            {children}
        </RecurringItemContext.Provider>
    );
};

export default RecurringItemProvider;
